import FetchClientToken from '@/services/payments/FetchClientToken';

export default class PrimerService {
    fetchClientToken(email) {
        return (new FetchClientToken()).handle(email);
    }
}
